module.exports = __webpack_public_path__ + "fonts/rubik-bold-webfont.52fe042b.52fe042b.ttf";